<template>
  <b-container>
    <b-card title="Sign up" class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4">
      <b-form @submit.prevent="signUp">
        <b-form-group label="Email" label-class="font-weight-bold">
          <b-form-input
            type="email"
            placeholder="example@example.com"
            v-model="user.email"
            :state="feedback.email ? !feedback.email : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.email"
            v-if="feedback.email"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Password"
          description="Password must be at least 8 characters long and contain at least 1 uppercase letter, 1 lowercase letter and 1 digit."
          label-class="font-weight-bold"
        >
          <b-form-input
            type="password"
            v-model="user.password"
            :state="feedback.password ? !feedback.password : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.password"
            v-if="feedback.password"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Password confirmation"
          label-class="font-weight-bold"
        >
          <b-form-input
            type="password"
            v-model="passwordConfirmation"
            :state="
              user.password ? passwordConfirmation === user.password : null
            "
            required
          ></b-form-input>
          <b-form-invalid-feedback>
            비밀번호가 일치하지 않습니다.
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <b-form-group label="Name" label-class="font-weight-bold">
          <b-form-input
            type="text"
            v-model="user.name"
            :state="feedback.name ? !feedback.name : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.name"
            v-if="feedback.name"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Phone">
          <b-form-input
            type="tel"
            v-model="user.phone"
            :state="feedback.phone ? !feedback.phone : null"
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.phone"
            v-if="feedback.phone"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <b-form-group
          label="Username (URL)"
          label-class="font-weight-bold"
          description="The username must contain only letters, numbers, dot(.), at(@), underscore(_) and hyphen(-)."
        >
          <ul>
            <li>
              pixpills.com/<i>{{ user.username || "username" }}</i>
            </li>
          </ul>
          <b-form-input
            type="text"
            placeholder="username"
            v-model="user.username"
            :state="feedback.username ? !feedback.username : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.username"
            v-if="feedback.username"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <b-form-group label="Date of birth" label-class="font-weight-bold">
          <b-form-input
            type="date"
            placeholder="YYYY-MM-DD"
            v-model="user.date_of_birth"
            :state="feedback.date_of_birth ? !feedback.date_of_birth : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.date_of_birth"
            v-if="feedback.date_of_birth"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Gender" label-class="font-weight-bold">
          <b-form-radio-group
            v-model="user.gender"
            :state="feedback.gender ? !feedback.gender : null"
            required
          >
            <b-form-radio value="Male">Male</b-form-radio>
            <b-form-radio value="Female">Female</b-form-radio>
            <b-form-radio value="Other">Other</b-form-radio>
          </b-form-radio-group>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.gender"
            :style="{ display: feedback.gender ? 'block' : null }"
            v-if="feedback.gender"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <div class="submit-button-group">
          <b-button type="submit" variant="primary">Sign up</b-button>
          <b-button type="reset" class="mr-2">Reset</b-button>
        </div>
        By clicking Sign up, you agree to our
        <a
          href="https://www.notion.so/590d96138f8c445bb036e643925aa1e7"
          target="_blank"
          >Terms of Service</a
        >
        and that you have read our
        <a
          href="https://www.notion.so/441c977e812a46d59715a2867db3201a"
          target="_blank"
          >Privacy Policy</a
        >.
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import Vue from "vue";
import { User } from "../models";

export default Vue.component("signup", {
  data() {
    return {
      user: new User({
        categories: []
      }),
      passwordConfirmation: "",
      feedback: {}
    };
  },
  methods: {
    async signUp() {
      try {
        await this.user.save();
        window.location = "/";
      } catch ({ response }) {
        if (response.status === 400) {
          this.feedback = response.data;
        } else if (response.status === 403) {
          window.location = "/";
        }
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.submit-button-group {
  display: flex;
  flex-direction: row-reverse;
}
</style>
